// extracted by mini-css-extract-plugin
export default {"header":"CopyFeature_header__K-Qxw","content":"CopyFeature_content__ITnZH","text":"CopyFeature_text__nh5Vb"};